


const ContactPageData = {
    

    "FooterCtaSection":[
        {
            "CtaHeading": "Join the Innovation",
            "CtaDescriptiom":"Innovate Tech Solutions is dedicated to transforming ideas into reality. Let's explore the possibilities together.",
            "CtaBtnText": `Get in Touch`,
            "CtaBtnLink": '/get-a-quote',
        },
    ],


    
} 

export default ContactPageData